import axios from '../axios'
import { formatSelectOption as format } from '@/utils'
const loading = 'loading'
const cache = {}

/**
 * 获取业务类型
 */
export const getBusinessType = () => {
  if (cache.business) return cache.business
  return (cache.business = axios.post('/bzmj/admin/dropDown/business', null, { loading: 'business' }).then(({ data = {} }) => format(data.data), () => (cache.business = null)))
}

/**
 * 根据业务类型获取年度跟期数
 */
export const getParamsData = () => axios.post('/select/taskfilecondition', { timeout: 60 * 1000, loading: 'select' }).then(({ data = {} }) => {
  const { time } = data.data || {}
  return {
    period: format(time.period),
    year: format(time.year)
  }
})
/**
 * 音频参数
 */
export const getAudioParamsData = data=> axios.post('/bzmj/admin/Audio/select/common',data, { timeout: 60 * 1000, loading: 'select' }).then(({ data = {} }) => {
  const { month, report_from, audio_type, status, year } = data.data || {}
  return {
    period: format(month),
    report_from: format(report_from),
    audio_type: format(audio_type),
    status: format(status),
    year: format(year)
  }
})
/**
 * 音频文件列表
 */
export const getAudioLoadData = data => axios.post('/bzmj/admin/Audio/list', data, { timeout: 60 * 1000 }).then(({ data }) => data.data)
/**
 * 发布音频文件
 */
export const publishAudio = (type, id) => axios.post('/bzmj/admin/Audio/publish', { type, id }, { timeout: 60 * 1000, loading: 'publish' }).then(({ data = {} }) => data.message || '发布成功')
/**
 * 音频文件归属人
 */
export const getAudioFrom = data => axios.post('/bzmj/admin/Audio/select/common', data, { loading: 'reportfrom' }).then(({ data = {} }) => {
  const { report_from } = data.data || {}
  return format(report_from)
})
/**
 *删除文件
 */
export const deleteAudio = id => axios.post('/bzmj/admin/Audio/delete', { id }, { loading: 'deletereport' }).then(({ data = {} }) => data.message || '删除成功')

/**
 * 获取文件类型
 */
export const getFileType = () => axios.post('/bzmj/admin/dropDown/fileTypeSelect', null, { loading: 'filetype' }).then(({ data = {} }) => format(data.data))
/**
 * 获取文件格式
 */
export const getFileFormat = () => axios.post('/bzmj/admin/dropDown/fileFormatSelect', null, { loading: 'fileformat' }).then(({ data = {} }) => format(data.data, 'name', 'name'))

export const updateDMS = () => axios.post('/admin/bzmj/person/dms/update', null, { loading: 'updatedms', timeout: Infinity }).then(({ data = {} }) => data.message || '操作成功')

export const getUpdateTime = () => axios.post('/admin/bzmj/person/time').then(({ data = {} }) => data.data || '-')

export const getOfflineData = data => axios.post('/bzmj/admin/thirdTask/childTaskList', data, { loading }).then(({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  return { list, total }
})

export const dataImport = data => axios.post('/bzmj/admin/thirdTask/loadData', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  timeout: Infinity,
  loading: 'importdata'
}).then(({ data = {} }) => data.message || '操作成功')

export const deleteData = id => axios.post('/bzmj/admin/thirdTask/deleteData', { id }, { loading: 'deletedata' }).then(({ data = {} }) => data.message || '操作成功')

export const importImages = (data, callback) => axios.post('/bzmj/admin/thirdTask/loadPhotos', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  timeout: Infinity,
  loading: 'importimage',
  onUploadProgress: callback
}).then(({ data = {} }) => data.message || '操作成功')

export const photoList = data => axios.post('/bzmj/admin/thirdTask/photoList', data, { loading }).then(({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  return { list, total }
})

export const deleteImage = (id, photo_id, photo_type) => axios.post('/bzmj/admin/thirdTask/deletePhoto', { id, photo_id, photo_type }, { loading: 'photodelete' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 配置报告类型筛选
 */
export const reportConfigType = () => axios.post('/bzmj/admin/dropDown/config', null, { loading: 'config_type' }).then(({ data = {} }) => {
  const { config_type } = data.data || {}
  return format(config_type)
})

/***
 * 配置报告列表
 */
export const reportConfigList = data => axios.post('/bzmj/admin/config/select', data, { loading }).then(({ data = {} }) => {
  const { rows: list = [], total = 0 } = data.data || {}
  return { list, total }
})

/**
 * 导入配置文件
 */
export const importConfigFile = data => axios.post('/bzmj/admin/config/insert', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  loading: 'importfile',
  timeout: Infinity
}).then(({ data = {} }) => data.message || '操作成功')

/**
 * 删除配置文件
 */
export const deleteConfigFile = data => axios.post('/bzmj/admin/config/delete', data, { loading: 'deletefile' }).then(({ data = {} }) => data.message || '操作成功')

// page: 文件管理
/**
 * 文件一览
 */
export const getFileList = data => axios.post('/bzmj/admin/system/systemFileList', data, { loading }).then(({ data = {} }) => {
  const { row: list = [], total: total = 0  } = data.data || {}
  return { list, total }
})
/**
 * 批量删除文件
 * @param {string[]} files_id_arr 文件id数组
 */
export const deleteFiles = id  => axios.post('/bzmj/admin/system/delSystemFile', {  id  }, { loading: 'deletefile' }).then(({ data = {} }) => data.message || '操作成功')
/**
 * 切换文件启用状态
 */
export const switchSystemFile = (id, project_type) => axios.get('/bzmj/admin/system/changeSystemFileStatus', { id, project_type }, { loading: 'switchSystemFile' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 根据业务类型获取角色列表
 */
cache.role = {}
export const getRoleByBusinessType = business_id => {
  if (!business_id) return Promise.resolve([])
  if (cache.role[business_id]) return cache.role[business_id]
  return (cache.role[business_id] = axios.post('/bzmj/admin/dropDown/getRoleForBusinessType', { business_id }, { loading: 'rolelist' }).then(({ data = {} }) => data.data || [], () => (cache.role[business_id] = null)))
}

/**
 * 上传文件
 */
export const uploadSystemFile = data => axios.post('/bzmj/admin/system/uploadSystemFile', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  loading: 'submit',
  timeout: Infinity
}).then(({ data = {} }) => data.message || '操作成功')

/**
 * 上传或编辑文件
 */
export const modifySystemFile = data => axios.post('/bzmj/admin/system/updateSystemFile', data, {
  loading: 'submit'
}).then(({ data = {} }) => data.message || '操作成功')
/**
 * 发布文件
 */
export const publishSystemFile = (type, id) => axios.post('/bzmj/admin/system/publish', { type, id }, { timeout: 60 * 1000, loading: 'publish' }).then(({ data = {} }) => data.message || '发布成功')
/**
 * 文件参数
 */
export const getSystemFileParamsData = data=> axios.post('/bzmj/admin/system/select/common',data, { timeout: 60 * 1000, loading: 'select' }).then(({ data = {} }) => {
  const { month, report_from, audio_type, status, year } = data.data || {}
  return {
    period: format(month),
    report_from: format(report_from),
    audio_type: format(audio_type),
    status: format(status),
    year: format(year)
  }
})
/**
 * 导入报告数据
 */
export const importReportFile = data => axios.post('/bzmj/admin/thirdTask/reportData/loadData', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  timeout: Infinity,
  loading: 'submit'
}).then(({ data = {} }) => data.message || '操作成功')

/**
 * 报告数据
 */
export const reportList = data => axios.post('/bzmj/admin/thirdTask/reportData/list', data, { loading }).then(async ({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  const business = await getBusinessType()
  return {
    // eslint-disable-next-line
    list: list.map(item => Object.assign(item, { business_name: (business.find(it => it.value == item.business_id) || {})['label'] })),
    total
  }
})

/**
 * 删除报告数据
 */
export const deleteReport = report_upload_id => axios.post('/bzmj/admin/thirdTask/reportData/delete', { report_upload_id }, { loading: 'reportdelete' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 导入检核岗位
 * @param {FormData} data
 * @param {File} data.files
 */
export const importCheckPost = data => axios.post('/admin/bzmj/person/update', data, { loading: 'importpost' }).then(({ data = {} }) => data.message || '操作成功')
export default {
  updateDMS,
  getUpdateTime,
  getOfflineData,
  dataImport,
  deleteData,
  importImages,
  photoList,
  deleteImage,
  reportConfigType,
  reportConfigList,
  importConfigFile,
  deleteConfigFile,
  deleteFiles,
  getFileList,
  getBusinessType,
  getFileType,
  getFileFormat,
  switchSystemFile,
  getRoleByBusinessType,
  uploadSystemFile,
  modifySystemFile,
  importReportFile,
  reportList,
  deleteReport,
  importCheckPost,
  getParamsData,
  getAudioParamsData,
  getAudioLoadData,
  publishAudio,
  getAudioFrom,
  deleteAudio,
  publishSystemFile,
  getSystemFileParamsData
}
